"use client";
import isEmpty from "lodash/isEmpty";
import { useEffect } from "react";
import { useComponentLifecycle } from "@stadium/hooks/lib/use-component-lifecycle";

import { useStoreContext } from "@components/store/provider";
import { BREADCRUMB_BRAND, BREADCRUMB_SEARCH } from "@constants/breadcrumbs";
import ProductSearchList from "@components/store/products/listing/search";
import ProductListingProvider from "@components/store/products/listing/listing-provider";
import BottomIconHideWrapper from "@stadium/shared/src/components/bottom-icon-hide-wrapper";

const StoreProductsListing = ({ brand, searchQuery = "", searchedFor = "" }) => {
  const brandPresent = !isEmpty(brand);
  const props = !brandPresent ? { searchQuery, searchedFor } : { brand, searchedFor };

  const { setPageState, resetPageState } = useStoreContext();

  useComponentLifecycle({ onUnmount: resetPageState });

  useEffect(() => {
    setPageState((state) => ({
      ...state,
      withCatalogMode: true,
      pageType: brandPresent ? "brand" : "search",
      breadcrumbPageType: brandPresent ? BREADCRUMB_BRAND : BREADCRUMB_SEARCH,
    }));
  }, [brandPresent, setPageState]);

  return (
    <BottomIconHideWrapper>
      <ProductListingProvider>
        <ProductSearchList {...props} />
      </ProductListingProvider>
    </BottomIconHideWrapper>
  );
};

export default StoreProductsListing;
